import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateProduct } from '../services/products.api';
import type { UpdateProductDTO } from '../types';

interface UpdateProductVariables {
  id: string;
  data: UpdateProductDTO;
}

export function useUpdateProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: UpdateProductVariables) => updateProduct(id, data),
    onSuccess: (product) => {
      void queryClient.invalidateQueries({ queryKey: ['products', 'list'] });
      void queryClient.invalidateQueries({ queryKey: ['products', 'detail', product.id] });
    },
  });
}
